import { fade, makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  icon: {
    fontSize: 20
  }
}));